var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformationFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 1.33331C4.31808 1.33331 1.33331 4.31808 1.33331 7.99998C1.33331 11.6819 4.31808 14.6666 7.99998 14.6666C11.6819 14.6666 14.6666 11.6819 14.6666 7.99998C14.6627 4.31973 11.6802 1.33729 7.99998 1.33331ZM8.13886 4.11102C8.59909 4.11102 8.97219 4.48412 8.97219 4.94436C8.97219 5.40459 8.59909 5.77769 8.13886 5.77769C7.67862 5.77769 7.30552 5.40459 7.30552 4.94436C7.30552 4.48412 7.67862 4.11102 8.13886 4.11102ZM9.3888 11.611H7.16658C6.85975 11.611 6.61102 11.3623 6.61102 11.0555C6.61102 10.7486 6.85975 10.4999 7.16658 10.4999H7.58325C7.65995 10.4999 7.72213 10.4377 7.72213 10.361V7.86102C7.72213 7.78432 7.65995 7.72213 7.58325 7.72213H7.16658C6.85975 7.72213 6.61102 7.4734 6.61102 7.16658C6.61102 6.85975 6.85975 6.61102 7.16658 6.61102H7.72213C8.33578 6.61102 8.83325 7.10848 8.83325 7.72213V10.361C8.83325 10.4377 8.89543 10.4999 8.97213 10.4999H9.3888C9.69563 10.4999 9.94436 10.7486 9.94436 11.0555C9.94436 11.3623 9.69563 11.611 9.3888 11.611Z",
    fill: "#E46B67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationFilled);
export default __webpack_public_path__ + "static/media/information-filled.0e3bcb77.svg";
export { ForwardRef as ReactComponent };